module.exports = __webpack_public_path__ + "img/panelView_defaultBg_4_3.974f9567.png";